import {
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGIN_LOADING,
  RESET_PASSWORD,
} from "../actions/LoginActions";
import { USER_LOGGED_OUT } from "../actions/UserActions";
const initialState = {
  success: false,
  loading: false,
  error: "",
};

const LoginReducer = function (state = initialState, action) {
  switch (action.type) {
    case LOGIN_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }
    case LOGIN_SUCCESS: {
      return {
        ...state,
        success: true,
        loading: false,
      };
    }
    case RESET_PASSWORD: {
      return {
        ...state,
        success: true,
        loading: false,
      };
    }
    case LOGIN_ERROR: {
      return {
        success: false,
        loading: false,
        error: action.payload,
      };
    }
    case USER_LOGGED_OUT: {
      return {
        error: "",
        success: false,
        loading: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default LoginReducer;
